export default __webpack_public_path__ + "static/media/Group 3041.c02b2ccd.png";